import 'arrayq';

import { PureConnect, React } from '../../react';
import { INote } from '../../types';
import { notesEditor } from './resource';
import { Modal } from '../modal/index';
import UPDATE_BUTTON_NO, { itemButtonTypeActionDeleteItem } from '../../focuslock/actions/UPDATE_BUTTON_NO';
// import FocusLockFocusGuard from '../../focuslock/focuslockext';
import cx from './style.less';
import NoteDeleteArea from './noteDeleteArea';
import { NoteDeleteAreaSave } from './noteDeleteArea';
import NOTE_DELETE_WITH_CHAT from './actions/NOTE_DELETE_WITH_CHAT';

export default PureConnect('NotesDeleteModal')(
    (state) => ({
        deleting: notesEditor.selectors.deleting(state),
        item: notesEditor.selectors.item(state),
        origin: state.notemenu.origin,
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({
        cancelDelete: () => dispatch(notesEditor.actions.DELETE_CANCEL({ })),
        saveDelete: (item: INote) => dispatch(NOTE_DELETE_WITH_CHAT({ item })),
        setFocus: (buttonNr: number, origin: number) => {
            dispatch(UPDATE_BUTTON_NO({buttonNo: buttonNr, 
                                        origin: origin, 
                                        buttonAction: itemButtonTypeActionDeleteItem}));
        },
    }),
    ({ deleting, flyoverVisible, item, cancelDelete, saveDelete, setFocus, origin }) => {
        return (
            <Modal onEscKeyDown={cancelDelete} 
                visible={!flyoverVisible && deleting} 
                type="smallsize1"
                backdrop={true}
            >        
                {!flyoverVisible && deleting?   
                <div className={cx(!deleting ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!deleting} aria-labelledby= "Verwijder notitie">   
                    <NoteDeleteArea />
                    <NoteDeleteAreaSave />
                </div>: null}
            </Modal>             
        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/noteDeleteModal.tsx